module.exports = __webpack_public_path__ + "static/media/search_loop.bde45aac.svg";